import React, { useState, useRef } from 'react';

import { useTranslation } from "react-i18next";
//vibe-code (TM)
const AddCardForm = ({ onClose, onSubmit, onOtpSubmit }) => {
  const { t } = useTranslation("exchange");

  const [newCard, setNewCard] = useState({
    number: '',
    name: '',
    expiryDate: '',
    cardType: 'visa'
  });

  const input1Ref = useRef(null);
  const input2Ref = useRef(null);

  const [step, setStep] = useState("form"); // form | otp
  const [otp, setOtp] = useState("");

  const formatCardNumber = (value) => {
    const cleaned = value.replace(/\s/g, '');
    const match = cleaned.match(/\d{1,4}/g);
    return match ? match.join(' ').substr(0, 19) : '';
  };

  const formatExpiryDate = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length >= 2) {
      return cleaned.substring(0, 2) + (cleaned.length > 2 ? '/' + cleaned.substring(2, 4) : '');
    }
    return cleaned;
  };

  const detectCardType = (number) => {
    const cleaned = number.replace(/\s/g, '');
    if (cleaned.startsWith('4')) return 'visa';
    if (cleaned.startsWith('5') || cleaned.startsWith('2')) return 'mastercard';
    if (cleaned.startsWith('8600')) return 'uzcard';
    if (cleaned.startsWith('9860')) return 'humo';
    return 'visa';
  };

  const handleCardNumberChange = (e) => {
    const formatted = formatCardNumber(e.target.value);
    const cardType = detectCardType(formatted);
    setNewCard(prev => ({ 
      ...prev, 
      number: formatted,
      cardType: cardType
    }));
  };

  const handleExpiryChange = (e) => {
    const formatted = formatExpiryDate(e.target.value);
    setNewCard(prev => ({ ...prev, expiryDate: formatted }));
  };

  const handleSubmit = () => {
    if (isFormValid()) {
      // переход к OTP шагу
      
      // Можно сразу дернуть onSubmit чтобы на бэке ушёл запрос на отправку OTP
      const result = onSubmit({
        card_type: newCard.cardType,
        name: newCard.name,
        pan: newCard.number.replace(/\s/g, ''),
        expiryDate: newCard.expiryDate.replace("/",""),
      });
      if(result){
        setStep("otp");
      }
      else{
        setNewCard({ number: '', name: '', expiryDate: '', cardType: 'visa' });
        setOtp("");
        setStep("form");
        onClose();
      }
    }
  };

  const handleOtpSubmit = () => {
    if (otp.trim().length === 6) { // допустим OTP = 6 цифр
      onOtpSubmit(otp, newCard);

      // сброс состояния
      setNewCard({ number: '', name: '', expiryDate: '', cardType: 'visa' });
      setOtp("");
      setStep("form");

      // закрываем форму
      onClose();
    }
  };

  const isFormValid = () => {
    return (
      newCard.number.replace(/\s/g, '').length >= 16 && 
      newCard.name.trim() && 
      newCard.expiryDate.length === 5
    );
  };

  const getCardColor = (type) => {
    switch (type?.toLowerCase()) {
      case 'visa': return '#1A1F71';
      case 'mastercard': return '#EB001B';
      case 'uzcard': return '#00A651';
      case 'humo': return '#F79100';
      default: return '#4A90E2';
    }
  };
    
      return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg flex flex-col">
        {/* Шапка */}
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold text-gray-800">
            {step === "form" ? t("ADD_NEW_CARD") : t("SMS_CONFIRM")}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl font-bold w-6 h-6 flex items-center justify-center"
          >
            ×
          </button>
        </div>
      
        {/* Контент */}
        <div className="flex-1 overflow-y-auto p-4">
          {step === "form" && (
            <div className="space-y-4">
              {/* Превью карты */}
              {newCard.number && (
                <div className="mb-4 p-3 bg-gray-50 rounded-lg border">
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-7 rounded-md flex items-center justify-center text-white font-bold text-sm"
                      style={{ backgroundColor: getCardColor(newCard.cardType) }}
                    >
                      💳
                    </div>
                    <div className="flex flex-col gap-0.5">
                      <span className="text-sm font-semibold text-gray-800">
                        **** {newCard.number.slice(-4)}
                      </span>
                      <span className="text-xs text-gray-500 capitalize">
                        {newCard.cardType}
                      </span>
                    </div>
                    {newCard.name && (
                      <span className="text-xs text-gray-500 ml-auto">
                        {newCard.name}
                      </span>
                    )}
                  </div>
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("CARD_NUMBER")}*
                </label>
                <input
                  type="text"
                  value={newCard.number}
                  onChange={handleCardNumberChange}
                  placeholder="1234 5678 9012 3456"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors font-mono text-sm !text-black"
                  maxLength="19"
                  enterKeyHint="next"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      input1Ref.current?.focus();
                    }
                  }}
                />
                <div className="text-xs text-gray-500 mt-1">
                  {newCard.number.replace(/\s/g, '').length}/{t("16_DIGITS")}
                </div>
              </div>
            
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("CARD_NAME")}*
                </label>
                <input
                  ref={input1Ref}
                  type="text"
                  value={newCard.name}
                  onChange={(e) =>
                    setNewCard((prev) => ({ ...prev, name: e.target.value }))
                  }
                  placeholder="Uzcard, Humo, Visa..."
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors !text-black"
                  maxLength="20"
                  enterKeyHint="next"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      input2Ref.current?.focus();
                    }
                  }}
                />
              </div>
                
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  {t("CARD_CVV")}*
                </label>
                <input
                  ref={input2Ref}
                  type="text"
                  value={newCard.expiryDate}
                  onChange={handleExpiryChange}
                  placeholder="MM/YY"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-colors !text-black"
                  maxLength="5"
                  enterKeyHint="go"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      if(!isFormValid()) return;
                      handleSubmit();
                    }
                  }}
                />
              </div>
                
              <div className="flex gap-2 pt-4">
                <button
                  onClick={handleSubmit}
                  disabled={!isFormValid()}
                  className="flex-1 bg-blue-500 text-white rounded-lg py-3 font-medium hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                >
                  {t("ADD_CARD")}
                </button>
                <button
                  onClick={onClose}
                  className="flex-1 bg-gray-200 text-gray-800 rounded-lg py-3 font-medium hover:bg-gray-300"
                >
                  {t("CANCEL")}
                </button>
              </div>
            </div>
          )}

          {step === "otp" && (
            <div className="space-y-4">
              <p className="text-sm text-gray-600">
                {t("SMS_SENDED_MSG")}.
              </p>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Введите OTP"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-center text-lg tracking-widest text-sm !text-black"
                maxLength="6"
                enterKeyHint="go"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if(otp.length === 6) handleOtpSubmit();
                  }
                }}
              />
              <div className="flex gap-2 pt-4">
                <button
                  onClick={handleOtpSubmit}
                  disabled={otp.length !== 6}
                  className="flex-1 bg-green-500 text-white rounded-lg py-3 font-medium hover:bg-green-600 disabled:bg-gray-300"
                >
                  {t("CONFIRM")}
                </button>
                <button
                  onClick={() => setStep("form")}
                  className="flex-1 bg-gray-200 text-gray-800 rounded-lg py-3 font-medium hover:bg-gray-300"
                >
                  {t("BACK")}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCardForm;
